<template>
	<div class="card">
		<h3 class="title">
			<img :src="iconStoreInformationTitle" alt="" />
			{{ $t('merchant.transaction.text1') }}
		</h3>
	</div>
	<div class="card mb_0">
		<div v-if="isShowList">
			<div
				:class="[
					isMobile ? 'd_block' : 'd_flex',
					'align_items_end',
					'mt_20',
					'merchant_list',
					'justify_between',
				]"
			>
				<div :class="[isMobile ? 'd_block' : 'd_flex', 'align_items_end']">
					<div class="d_flex align_items_end">
						<div class="info mr_10">
							<p class="mb_10">{{ $t('rtr_activity.start') }}</p>
							<date-picker
								is-required
								v-model="startDate"
								:model-config="{ type: 'string' }"
								:locale="$store.state.common.locale"
								mode="dateTime"
								is24hr
							>
								<template v-slot="{ inputValue, inputEvents }">
									<label class="calendar_area">
										<input
											class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
											:value="inputValue"
											v-on="inputEvents"
										/>
									</label>
								</template>
							</date-picker>
						</div>
						<div class="info mr_10">
							<p class="mb_10">{{ $t('rtr_activity.end') }}</p>
							<date-picker
								is-required
								v-model="endDate"
								:model-config="{ type: 'string' }"
								:locale="$store.state.common.locale"
								mode="dateTime"
								is24hr
							>
								<template v-slot="{ inputValue, inputEvents }">
									<label class="calendar_area">
										<input
											class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
											:value="inputValue"
											v-on="inputEvents"
										/>
									</label>
								</template>
							</date-picker>
						</div>
					</div>
					<div :class="['info', 'search_area', isMobile ? 'mt_10' : 'mr_10']">
						<input
							type="text"
							:placeholder="$t('input.placeholder.search_activity')"
						/>
						<span
							class="search_icon SEARCH"
							@click="loadTransactionList"
						></span>
					</div>
				</div>
				<button
					type="button"
					:class="['button_bg_blue', isMobile ? 'w100 mt_10' : '']"
					@click="excelDownload"
				>
					<img
						:src="iconBtnState"
						alt=""
						class=""
						:style="
							isMobile
								? { width: '16px', height: '16px' }
								: { width: '20px', height: '20px' }
						"
					/>
					<span>{{ $t('rtr_activity.button1') }}</span>
				</button>
			</div>

			<div class="transaction_history mt_20">
				<div class="total_area">
					<div>
						<div class="text">{{ $t('merchant.transaction.total_count') }}</div>
						<div class="num">{{ summary.count }}</div>
						<div class="text2">{{ $t('merchant.transaction.count') }}</div>
					</div>
					<div>
						<div class="text">
							{{ $t('merchant.transaction.total_amount') }}
						</div>
						<div class="num">{{ summary.sum }}</div>
						<div class="text2">JPYS</div>
					</div>
				</div>
				<div v-if="transactionList.length === 0" class="list_none">
					<span class="ERRORGRAY"></span>
					<p>{{ $t('merchant.transaction.empty') }}</p>
				</div>
				<div v-else>
					<table v-if="!isMobile" class="table_type mb_40">
						<colgroup>
							<col style="width: 50px" />
							<col style="width: 50px" />
							<col style="width: 170px" />
							<col style="width: 170px" />
							<col style="width: 140px" />
							<col style="width: 140px" />
							<col style="width: 100px" />
							<col style="width: 120px" />
							<col style="width: 180px" />
						</colgroup>
						<thead>
							<tr>
								<th @click="checkboxHandler">
									<input
										class="ml_10 mr_10 checkbox"
										type="checkbox"
										v-model="isAllChecked"
									/>
								</th>
								<th>No</th>
								<!--									<th>결제시간</th>-->
								<!--									<th>거래명</th>-->
								<!--									<th>거래 ID</th>-->
								<!--									<th>결제자명</th>-->
								<!--									<th>거래유형</th>-->
								<!--									<th>상태</th>-->
								<!--									<th>결제금액</th>-->

								<th>{{ $t('merchant.transaction.table.time') }}</th>
								<th>{{ $t('merchant.transaction.table.name') }}</th>
								<th>{{ $t('merchant.transaction.table.id') }}</th>
								<th>{{ $t('merchant.transaction.table.payer') }}</th>
								<th>{{ $t('merchant.transaction.table.type') }}</th>
								<th>{{ $t('merchant.transaction.table.status') }}</th>
								<th>{{ $t('merchant.transaction.table.amount') }}</th>
							</tr>
						</thead>
						<tbody>
							<!--							<tr>-->
							<tr
								v-for="item in transactionList"
								:key="item.seq"
								@click="showDetail(item)"
							>
								<td @click.stop="">
									<input
										type="checkbox"
										class="checkbox ml_10 mr_10"
										v-model="item.checked"
									/>
								</td>
								<td>{{ item._no }}</td>
								<td>
									{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
								</td>
								<td>{{ item.title }}</td>
								<td>{{ item.transaction_id }}</td>
								<td>{{ item.payer_name }}</td>
								<td>{{ item.transaction_type }}</td>
								<td>{{ item.status }}</td>
								<td>{{ item.amount + ' ' + item.asset_code }}</td>
							</tr>
						</tbody>
					</table>

					<div v-if="isMobile" class="table_mobile">
						<div
							v-for="item in transactionList"
							:key="item.seq"
							class="card table_mobile_item"
							@click="showDetail(item)"
						>
							<div class="list num">{{ item._no }}</div>
							<div class="list">
								<div class="list_tit">
									{{ $t('merchant.transaction.table.time') }}
								</div>
								<div class="list_text">
									{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
								</div>
							</div>
							<div class="list">
								<div class="list_tit">
									{{ $t('merchant.transaction.table.name') }}
								</div>
								<div class="list_text">{{ item.title }}</div>
							</div>
							<div class="list">
								<div class="list_tit">
									{{ $t('merchant.transaction.table.id') }}
								</div>
								<div class="list_text">{{ item.transaction_id }}</div>
							</div>
							<div class="list">
								<div class="list_tit">
									{{ $t('merchant.transaction.table.payer') }}
								</div>
								<div class="list_text">{{ item.payer_name }}</div>
							</div>
							<div class="list">
								<div class="list_tit">
									{{ $t('merchant.transaction.table.type') }}
								</div>
								<div class="list_text">{{ item.transaction_type }}</div>
							</div>
							<div class="list">
								<div class="list_tit">
									{{ $t('merchant.transaction.table.status') }}
								</div>
								<div class="list_text">{{ item.status }}</div>
							</div>
							<div class="list">
								<div class="list_tit">
									{{ $t('merchant.transaction.table.amount') }}
								</div>
								<div class="list_text">
									{{ item.amount + ' ' + item.asset_code }}
								</div>
							</div>
						</div>
					</div>

					<pagination
						v-if="transactionList.length !== 0"
						:totalCount="pageNavigation.total_count"
						:totalPage="pageNavigation.total_page"
						:curPage="pageNavigation.cur_page"
						:point="pageNavigation.point"
						:firstPage="pageNavigation.first_page"
						:lastPage="pageNavigation.last_page"
						@change="pageChangeHandler"
					></pagination>
				</div>
			</div>
		</div>

		<div v-if="!isShowList" class="mt_20 transaction_detail">
			<div class="card_inner">
				<table class="table_type table_type_detail">
					<colgroup>
						<col style="width: 180px" />
					</colgroup>
					<tbody>
						<tr>
							<th>{{ $t('merchant.transaction.table.order_no') }}</th>
							<td>{{ transactionInfo.order_id }}</td>
						</tr>
						<tr>
							<th>{{ $t('merchant.transaction.table.name') }}</th>
							<td>{{ transactionInfo.title }}</td>
						</tr>
						<tr>
							<th>{{ $t('merchant.transaction.table.id') }}</th>
							<td>{{ transactionInfo.transaction_id }}</td>
						</tr>
						<tr>
							<th>{{ $t('merchant.transaction.table.payer') }}</th>
							<td>{{ transactionInfo.payer_name }}</td>
						</tr>
						<tr>
							<th>{{ $t('merchant.transaction.table.amount') }}</th>
							<td>
								{{ transactionInfo.amount + ' ' + transactionInfo.asset_code }}
							</td>
						</tr>
						<tr>
							<th>{{ $t('merchant.transaction.table.type') }}</th>
							<td>{{ transactionInfo.transaction_type }}</td>
						</tr>
						<tr>
							<th>{{ $t('merchant.transaction.table.status') }}</th>
							<td>{{ transactionInfo.status }}</td>
						</tr>
						<tr>
							<th>{{ $t('merchant.transaction.table.time') }}</th>
							<td>
								{{
									$dayjs(transactionInfo.regdate).format('YYYY.MM.DD HH:mm:ss')
								}}
							</td>
						</tr>
					</tbody>
				</table>
				<div class="button_area">
					<button class="button_bg_blue" @click="back">
						{{ $t('button.back') }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import pagination from '@/components/Pagination';
import { commonError } from '@/common/dialog';
import { fetchMerchantTransactionList } from '@/api/merchant';
import { mapGetters } from 'vuex';
import { utils, writeFile } from 'xlsx';
import iconStoreInformationTitle from '@/assets/images/v2/icon/icon-store-information-title.svg';
import iconBtnState from '@/assets/images/v2/icon/icon-btn-state.svg';

export default {
	name: 'TransactionList',
	components: {
		pagination,
	},
	data() {
		return {
			isAllChecked: false,
			excelHeaders: {
				no: 'No',
				regdate: this.$t('merchant.transaction.table.time'),
				title: this.$t('merchant.transaction.table.name'),
				transactionId: this.$t('merchant.transaction.table.id'),
				payerName: this.$t('merchant.transaction.table.payer'),
				transactionType: this.$t('merchant.transaction.table.type'),
				status: this.$t('merchant.transaction.table.status'),
				amount: this.$t('merchant.transaction.table.amount'),
			},
			transactionList: [],
			isShowList: true,
			startDate: this.$dayjs(new Date())
				.add(-6, 'month')
				.startOf('day')
				.toDate(),
			endDate: this.$dayjs(new Date()).endOf('day').toDate(),
			transactionInfo: {},
			pageNavigation: {},
			curPage: 1,
			listCount: 30,
			summary: {
				count: 0,
				sum: 0,
			},
			iconStoreInformationTitle,
			iconBtnState,
			isMobile: false,
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		isListAllCheck() {
			let check = this.transactionList.length > 0;
			this.transactionList.forEach(item => {
				if (!item.checked) {
					check = false;
					return false;
				}
			});
			return check;
		},
	},
	watch: {
		isListAllCheck() {
			this.isAllChecked = this.isListAllCheck;
		},
	},
	created() {
		this.init();
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		back() {
			this.isShowList = true;
		},
		init() {
			Promise.all([this.loadTransactionList()]);
		},
		async loadTransactionList() {
			let regdate_start = '',
				regdate_end = '';
			if (this.startDate) {
				regdate_start = new Date(this.startDate).getTime();
			}
			if (this.endDate) {
				regdate_end = new Date(this.endDate).getTime();
			}

			const { data, page_navigation } = await fetchMerchantTransactionList({
				...this.$route.query,
				...this.$route.params,
				regdate_start: regdate_start,
				regdate_end: regdate_end,
				page: this.curPage,
				list_count: this.listCount,
			}).catch(commonError);

			this.transactionList = data;
			this.pageNavigation = page_navigation;
			this.getSummary();
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadTransactionList();
		},
		getSummary() {
			let sum = 0;
			this.transactionList.forEach(item => {
				sum += item.amount * 1;
			});
			this.summary.count = this.transactionList.length;
			this.summary.sum = sum;
		},
		checkboxHandler() {
			this.transactionList.forEach(item => {
				item.checked = !this.isAllChecked;
			});
		},
		excelDownload() {
			const excelData = this.makeExcelData();
			if (!excelData) return;
			const dataWS = utils.json_to_sheet(excelData, {
				skipHeader: true,
			});
			const wb = utils.book_new();
			utils.book_append_sheet(wb, dataWS, 'transactionList');
			writeFile(wb, 'transactionList.xlsx');
		},
		makeExcelData() {
			const excelData = [];
			const checkedList = this.transactionList.filter(item => {
				return item.checked === true;
			});

			if (checkedList.length === 0) {
				alert(this.$t('alert.transaction_check'));
				return false;
			}
			excelData.push(this.excelHeaders);
			checkedList.forEach(item => {
				const obj = {
					no: item._no,
					regdate: this.$dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss'),
					title: item.title,
					transactionId: item.transaction_id,
					payerName: item.payer_name,
					transactionType: item.transaction_type,
					status: item.status,
					amount: `${item.amount} ${item.asset_code}`,
				};
				excelData.push(obj);
			});

			return excelData;
		},
		showDetail(transactionInfo) {
			this.transactionInfo = transactionInfo;
			this.isShowList = false;
		},
		checkMobile() {
			this.isMobile = window.innerWidth <= 768;
		},
	},
};
</script>
